import { useContext } from "react";
import DashboardContext from "../components/DashboardComponents.js/context/DashboardProvider";

export const useDashboardContext = () => {
    return useContext(DashboardContext);
};